import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("minit_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Ralat berlaku. Sila cuba lagi.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const fmtTime = (sec) => {
  const s = Math.floor(sec || 0);
  const h = Math.floor(s / 3600);
  const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
  const ss = String(s % 60).padStart(2, "0");
  return h ? `${h}:${mm}:${ss}` : `${mm}:${ss}`;
};

export const parseTs = (ts) => ts.split(":").map(Number).reduce((a, b) => a * 60 + b, 0);

export const fmtDate = (iso, lang = "ms") =>
  iso ? new Date(iso).toLocaleDateString(lang === "en" ? "en-MY" : "ms-MY", { day: "numeric", month: "short", year: "numeric" }) : "";

export async function streamChat(body, { onSources, onDelta, onError }, path = "/chat") {
  const res = await fetch(`${API}${path}`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${localStorage.getItem("minit_token") || ""}` },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || "Gagal menghubungi AI");
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buf = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buf += decoder.decode(value, { stream: true });
    const events = buf.split("\n\n");
    buf = events.pop();
    for (const ev of events) {
      if (!ev.startsWith("data: ")) continue;
      const msg = JSON.parse(ev.slice(6));
      if (msg.type === "sources") onSources?.(msg.sources);
      else if (msg.type === "delta") onDelta?.(msg.content);
      else if (msg.type === "error") onError?.(msg.content);
    }
  }
}

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
